<template>
  <div>
    <el-row :gutter="20" class="left-style" style="margin-bottom: 10px">
      <el-select v-model="valueApp" placeholder="请选择APP名字" clearable>
        <el-option
          v-for="item in optionsApp"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <el-select
        v-model="valueMode"
        placeholder="请选择APP环境"
        style="margin-left: 10px"
        clearable
      >
        <el-option
          v-for="item in optionsMode"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <el-select
        v-model="valuePlatform"
        placeholder="请选择平台"
        style="margin-left: 10px"
        clearable
      >
        <el-option
          v-for="item in optionsPlatform"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <el-input
        v-model="inputVersion"
        placeholder="请输入版本->v1.0.0"
        style="width: 400px; margin-left: 10px"
        @keyup.enter.native="onEnter"
      ></el-input>
      <el-button
        @click="clear"
        type="danger"
        icon="el-icon-delete"
        circle
        style="margin-left: 10px"
      ></el-button>
      <!-- <el-cascader :props="props" style="width:400px;margin-left:10px;"></el-cascader> -->
    </el-row>
    <el-table :data="tableData" border style="width: 100%" stripe>
      <el-table-column
        prop="state"
        label="当前状态"
        width="120"
        style="align: center"
      >
        <template slot-scope="scope">
          <el-switch
            :value="!scope.row.expired"
            active-color="#13ce66"
            inactive-color="#ff4949"
            @change="changeState(scope.row.id, !scope.row.expired)"
          >
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column label="平台" width="80">
        {{ valuePlatform }}
      </el-table-column>
      <el-table-column prop="app_name" label="App种类" width="200">
      </el-table-column>
      <!-- <el-table-column prop="name" label="文件名" width="250">
      </el-table-column> -->
      <el-table-column prop="version" label="版本" width="120">
      </el-table-column>
      <el-table-column prop="mode" label="环境" width="120"> </el-table-column>
      <el-table-column prop="upload_time" label="上传时间" width="150">
        <template slot-scope="scope">
          <el-row>
            {{
              new Date(scope.row.upload_timestamp * 1000)
                .toLocaleString()
                .split(" ")[0]
            }}
          </el-row>
          <el-row>
            {{
              new Date(scope.row.upload_timestamp * 1000)
                .toLocaleString()
                .split(" ")[1]
            }}
          </el-row>
        </template>
      </el-table-column>
      <el-table-column prop="path" label="文件路径"> </el-table-column>
      <el-table-column prop="more_info" label="更多信息"> </el-table-column>
      <el-table-column fixed="right" label="操作" width="200">
        <template slot-scope="scope">
          <el-button
            @click="showMoreInfoMessageBox(scope.row)"
            plain
            size="small"
            >编辑Info</el-button
          >
          <!-- <el-button type="text" size="small">编辑</el-button> -->
          <el-button
            @click="showDeleteMessageBox(scope.row)"
            size="small"
            type="danger"
            >删除</el-button
          >
          <!-- <el-button type="text" size="small">编辑</el-button> -->
        </template>
      </el-table-column>
    </el-table>

    <el-dialog title="确认删除么？" :visible.sync="dialogTableVisible">
      <el-form :model="deleteForm" label-position="left">
        <el-form-item
          v-if="deleteForm.data != null"
          label="APP名字"
          label-width="100px"
        >
          <el-input v-model="deleteForm.data.app_name" disabled></el-input>
        </el-form-item>
        <el-form-item
          v-if="deleteForm.data != null"
          label="APP版本"
          label-width="100px"
        >
          <el-input v-model="deleteForm.data.version" disabled></el-input>
        </el-form-item>
        <el-form-item
          v-if="deleteForm.data != null"
          label="APP环境"
          label-width="100px"
        >
          <el-input v-model="deleteForm.data.mode" disabled></el-input>
        </el-form-item>
        <el-form-item
          v-if="deleteForm.data != null"
          label="APP环境"
          label-width="100px"
        >
          <el-input v-model="deleteForm.data.platform" disabled></el-input>
        </el-form-item>
        <el-form-item
          v-if="deleteForm.data != null"
          label="APP路径"
          label-width="100px"
        >
          <el-input v-model="deleteForm.data.path" disabled></el-input>
        </el-form-item>
        <el-form-item
          label="是否强制删除文件 (如果删除重复记录请不要勾选此选项)"
        >
          <el-switch v-model="deleteForm.force_delete"></el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogTableVisible = false">取 消</el-button>
        <el-button type="primary" @click="deleteConfirm">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
let id = 0;
import qs from "qs";
export default {
  data() {
    return {
      optionsApp: [
        {
          value: "comiru",
          label: "Comiru",
        },
        {
          value: "comiruRecorder",
          label: "Comiru入退室",
        },
        {
          value: "comiruAir",
          label: "ComiruAir",
        },
        {
          value: "comiruim",
          label: "ComiruIM",
        },
        {
          value: "schoolbus",
          label: "スクールバス",
        },
      ],
      optionsMode: [
        {
          value: "stage",
          label: "stage",
        },
        {
          value: "prod",
          label: "本番",
        },
        {
          value: "others",
          label: "其他",
        },
      ],
      optionsPlatform: [
        {
          value: "android",
          label: "Android",
        },
        {
          value: "ios",
          label: "iOS",
        },
        {
          value: "mac",
          label: "Mac",
        },
        {
          value: "windows",
          label: "Windows",
        },
      ],
      valueMode: "stage",
      valueApp: "comiru",
      valuePlatform: "ios",
      inputVersion: "",
      tableData: [
        {
          app_name: "comiru",
          mode: "stage",
          name: "app-release.apk",
          file: "/aaaaaa/aaaa",
          version: "v3.1.1",
          state: true,
        },
      ],
      props: {
        lazy: true,
        lazyLoad(node, resolve) {
          const { level } = node;
          setTimeout(() => {
            const nodes = Array.from({ length: level + 1 }).map((item) => ({
              value: ++id,
              label: `选项${id}`,
              leaf: level >= 2,
            }));
            // 通过调用resolve将子节点数据返回，通知组件数据加载完成
            resolve(nodes);
          }, 1000);
        },
      },
      deleteForm: {
        item_id: -1,
        data: null,
        force_delete: false,
      },
      dialogTableVisible: false,
    };
  },
  methods: {
    onEnter() {
      console.log(this.inputVersion);
      this.getList();
    },
    handleClick(row) {
      console.log(row);
    },
    getList() {
      // var api = "http://localhost:8000/getList/";
      var api = "/getList/";
      var data_map = {};
      if (this.valueApp != null && this.valueApp != "") {
        data_map["app_name"] = this.valueApp;
      }
      if (this.valueMode != null && this.valueMode != "") {
        data_map["mode"] = this.valueMode;
      }
      if (this.inputVersion != null && this.inputVersion != "") {
        data_map["version"] = this.inputVersion;
      }

      if (this.valuePlatform != null && this.valuePlatform != "") {
        data_map["platform"] = this.valuePlatform;
      }
      this.axios
        .get(api, {
          params: data_map,
        })
        .then((response) => {
          console.log(response.data);
          if (response.data.code == 200) {
            this.tableData = response.data.data;
          }
        });
    },
    changeState(id, expired) {
      // var api = "http://localhost:8000/changeState/";
      var api = "/changeState/";
      var data_map = {};
      console.log({
        item_id: id,
        expired: expired,
      });
      this.axios
        .post(
          api,
          this.$qs.stringify({
            item_id: id.toString(),
            expired: expired,
          })
        )
        .then((response) => {
          console.log(response);
          this.getList();
        });
    },
    showMoreInfoMessageBox(data) {
      this.$prompt("请输入更多信息", "提示", {
        inputValue: data.moer_info,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(({ value }) => {
          if (value == data.more_info) {
            this.$message({
              type: "info",
              message: "输入数据无修改",
            });
          } else this.updateMoreInfo(data.id, value);
        })
        .catch(() => {
          // this.$message({
          //   type: "info",
          //   message: "取消输入",
          // });
        });
    },
    updateMoreInfo(id, info) {
      // var api = "http://localhost:8000/updateMoreInfo/";
      var api = "/updateMoreInfo/";
      var data_map = {};
      console.log({
        item_id: id,
        more_info: info,
      });
      this.axios
        .post(
          api,
          this.$qs.stringify({
            item_id: id.toString(),
            more_info: info,
          })
        )
        .then((response) => {
          console.log(response);
          this.$message({
            type: "success",
            message: "更新成功: " + response.data.message,
          });
          this.getList();
        });
    },
    clear() {
      this.valueMode = "";
      this.valueApp = "";
      this.valuePlatform = "";
      this.inputVersion = "";
    },
    showDeleteMessageBox(data) {
      this.deleteForm.data = data;
      this.deleteForm.item_id = data.id;
      this.dialogTableVisible = true;
    },
    deleteConfirm() {
      this.dialogTableVisible = false;
      if (this.deleteForm != null) {
        var api = "/delete/";
        console.log({
          item_id: this.deleteForm.item_id,
          force_delete: this.deleteForm.force_delete,
        });
        this.axios
          .post(
            api,
            this.$qs.stringify({
              item_id: this.deleteForm.item_id,
              force_delete: this.deleteForm.force_delete,
            })
          )
          .then((response) => {
            console.log(response);
            this.$message({
              message: response.data.message,
              type: "success",
            });
            this.getList();
          });
      }
    },
  },
  mounted() {
    this.getList();
  },
  watch: {
    valueApp(oldV, newV) {
      this.getList();
    },
    valueMode(oldV, newV) {
      this.getList();
    },
    valuePlatform(oldV, newV) {
      this.getList();
    },
  },
};
</script>

<style>
.left-style {
  text-align: left;
  padding-left: 10px;
}
</style>